import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { memoizedFetchSitePersonalization } from '@atlassian/jira-personalization-service/src/services/site/index.tsx';
import type { Trait } from '@atlassian/jira-personalization-service/src/types.tsx';

export const CONFLUENCE_ACTIVATION_DATE = 'confluence.ondemand.activationDate';

export const useSiteEligibilityCheck = (cloudId: string) =>
	useCallback(async (): Promise<boolean> => {
		try {
			const siteTraits = await memoizedFetchSitePersonalization({ cloudId });
			return isSite7DaysOlder(siteTraits);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'useSiteEligibilityCheck',
					packageName: 'jiraCrossJoinThirdPartyNudges',
				},
				attributes: {
					cloudId,
					errorResponse: JSON.stringify(error),
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			throw new Error('Site eligibility check error');
		}
	}, [cloudId]);

const isSite7DaysOlder = (traits: Trait[]): boolean => {
	const confluenceActivation = traits.find((trait) => trait.name === CONFLUENCE_ACTIVATION_DATE);

	if (confluenceActivation?.value) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const oneWeekLaterActivation = new Date(confluenceActivation?.value as string);
		oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
		const today = new Date();
		return today >= oneWeekLaterActivation;
	}
	return false;
};
